import React from 'react';
import UserMenu from '../UserMenu';
import LanguageSwitcher from '../../../../components/LanguageSwitcher';

import style from './style.module.scss';

const TopBar = () => {
  return (
    <div className={style.topbar}>
      <div className='ml-auto mr-4 d-sm-block'>
        <LanguageSwitcher />
      </div>
      <div className='d-sm-block'>
        <UserMenu />
      </div>
    </div>
  );
};

export default TopBar;
